export const actions = {
  PRODUCTO_GENERICO_LOAD_REQUESTED: 'PRODUCTO_GENERICO_LOAD_REQUESTED',
  PRODUCTO_GENERICO_LOAD_SUCCEEDED: 'PRODUCTO_GENERICO_LOAD_SUCCEEDED',
  PRODUCTO_GENERICO_LOAD_FAILED: 'PRODUCTO_GENERICO_LOAD_FAILED',

  PRODUCTO_GENERICO_INSERT_REQUESTED: 'PRODUCTO_GENERICO_INSERT_REQUESTED',
  PRODUCTO_GENERICO_INSERT_SUCCEEDED: 'PRODUCTO_GENERICO_INSERT_SUCCEEDED',
  PRODUCTO_GENERICO_INSERT_FAILED: 'PRODUCTO_GENERICO_INSERT_FAILED',

  PRODUCTO_GENERICO_UPDATE_REQUESTED: 'PRODUCTO_GENERICO_UPDATE_REQUESTED',
  PRODUCTO_GENERICO_UPDATE_SUCCEEDED: 'PRODUCTO_GENERICO_UPDATE_SUCCEEDED',
  PRODUCTO_GENERICO_UPDATE_FAILED: 'PRODUCTO_GENERICO_UPDATE_FAILED',

  PRODUCTO_GENERICO_DELETE_REQUESTED: 'PRODUCTO_GENERICO_DELETE_REQUESTED',
  PRODUCTO_GENERICO_DELETE_SUCCEEDED: 'PRODUCTO_GENERICO_DELETE_SUCCEEDED',
  PRODUCTO_GENERICO_DELETE_FAILED: 'PRODUCTO_GENERICO_DELETE_FAILED',
}

export const getProductosGenericosAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_LOAD_REQUESTED,
    payload,
  })
}

export const setProductosGenericosAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_INSERT_REQUESTED,
    payload,
  })
}

export const updateProductosGenericosAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteProductosGenericosAction = (dispatch, id) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_DELETE_REQUESTED,
    id,
  })
}
